import React, { useEffect, useState } from 'react';
import { Button, Card, Col, DatePicker, Form, Input, InputNumber, message, Popconfirm, Row, Select, Space } from 'antd';
import { useGetAreaQuery, useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import { createJsonOptions } from '@/scripts/utils';
import { FORM_RULE_REQUIRED } from '@/scripts/config';
import dayjs from 'dayjs';
import ajax from '@/scripts/ajax';
import _ from 'lodash';

const defaultValue = {
    account_num: 1,
    account_end: 50,
    cargo_weight: 15000,
    cargo_details: 'Fabrics, textiles',
    quantity: 1,
    export_service_mode: 'CY',
    import_service_mode: 'CY',
    free_time_days: 0,
    origin_location: 'NingBo,104T898SJZ6GU',
    container_details: '40 Dry High',
};

const serviceModeOptions = [
    { label: 'CY', value: 'CY' },
    { label: 'SD', value: 'SD' },
];

export default function MakeOrderCIDForm(props) {
    const { id, cache, onValueChange } = props;
    const [form] = Form.useForm();

    const { data: startPortOptions } = useGetStartPortQuery(0);
    const { data: endPortOptions } = useGetEndPortQuery(0);
    const { data: areaOptions } = useGetAreaQuery();
    const [submitting, setSubmitting] = useState(false);
    const [formDefaultValue, setFormDefaultValue] = useState(null);

    useEffect(() => {
        if (cache && cache.earliest_departure_date) {
            const { earliest_departure_date: time } = cache;
            cache.earliest_departure_date = _.isString(time) ? dayjs(time) : time;
        }
        setFormDefaultValue(cache || { ...defaultValue });
    }, []);

    const handleSubmit = () => {
        form.validateFields()
            .then((formValue) => {
                setSubmitting(true);
                const { earliest_departure_date, ...rest } = formValue;
                const value = {
                    earliest_departure_date: dayjs(earliest_departure_date).format('YYYY-MM-DD 00:00:00'),
                    ...rest,
                };
                // let startIndex = value.account_num;
                // let endIndex = value.account_end;
                // let queryArr = [];

                // while (startIndex <= endIndex) {
                //     let queryValue = { ...value, ...{ account_num: startIndex } };
                //     queryArr.push(() => ajax.post('/book/ini', queryValue));
                //     startIndex++;
                // }

                // Promise.all(queryArr.map((item) => item()))
                //     .then((res) => {
                //         message.info(res[0]);
                //     })
                //     .finally(() => {
                //         setSubmitting(false);
                //     });
                ajax.post('book/ini', value)
                    .then((res) => {
                        message.info(res);
                    })
                    .catch((err) => {
                        console.log(err, 'err');
                    })
                    .finally(() => {
                        setSubmitting(false);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleReset = () => {
        form.resetFields();
        form.setFieldsValue({ ...defaultValue });
        onValueChange(id, { ...defaultValue });
    };

    const handleDelete = () => {
        onValueChange(id, 'delete');
    };

    const handleValueChange = async () => {
        const formValue = await form.getFieldsValue();
        onValueChange(id, formValue);
    };

    if (!formDefaultValue) return null;

    return (
        <Form form={form} initialValues={formDefaultValue} onValuesChange={handleValueChange}>
            <Card style={{ minWidth: 1150 }}>
                <Row gutter={16}>
                    <Col span={6} style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Form.Item label="账号" name="account_num" required rules={[FORM_RULE_REQUIRED]}>
                            <InputNumber min={1} precision={0}></InputNumber>
                        </Form.Item>
                        <Form.Item noStyle name="account_end" required rules={[FORM_RULE_REQUIRED]}>
                            <InputNumber min={1} precision={0} style={{ marginLeft: 8 }}></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="重量" name="cargo_weight" required rules={[FORM_RULE_REQUIRED]}>
                            <InputNumber style={{ width: '100%' }}></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="品名" name="cargo_details" required rules={[FORM_RULE_REQUIRED]}>
                            <Input disabled></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="启始" name="origin_location" required rules={[FORM_RULE_REQUIRED]}>
                            <Select options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="订单" name="quantity" required rules={[FORM_RULE_REQUIRED]}>
                            <InputNumber style={{ width: '100%' }}></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                            <Form.Item label="模式" name="export_service_mode" required rules={[FORM_RULE_REQUIRED]}>
                                <Select options={serviceModeOptions}></Select>
                            </Form.Item>
                            <Form.Item noStyle name="import_service_mode" required rules={[FORM_RULE_REQUIRED]}>
                                <Select options={serviceModeOptions} style={{ marginLeft: 8 }}></Select>
                            </Form.Item>
                        </div>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="日期" name="earliest_departure_date" required rules={[FORM_RULE_REQUIRED]}>
                            <DatePicker />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="区域" name="area">
                            <Select options={createJsonOptions(areaOptions)} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}></Col>
                    <Col span={6}>
                        <Form.Item label="免用" name="free_time_days" required rules={[FORM_RULE_REQUIRED]}>
                            <Select
                                options={createJsonOptions(
                                    Array(22)
                                        .fill(0)
                                        .map((_, index) => index),
                                )}
                                showSearch
                                allowClear
                            ></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="箱型" name="container_details" required rules={[FORM_RULE_REQUIRED]}>
                            <Select
                                options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                                showSearch
                                allowClear
                            ></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="目的" name="destination_location" required rules={[FORM_RULE_REQUIRED]}>
                            <Select options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                </Row>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Space>
                        <Popconfirm title="确认" description="是否执行该操作?" onConfirm={handleDelete} okText="是" cancelText="否">
                            <Button danger ghost>
                                删除
                            </Button>
                        </Popconfirm>
                        <Button onClick={handleReset}>重置</Button>
                    </Space>

                    <Button onClick={handleSubmit} type="primary" loading={submitting}>
                        开始订舱
                    </Button>
                </div>
            </Card>
        </Form>
    );
}
